import React from 'react';
import PsleInstruction from './PsleInstruction';
import GceInstruction from './GceInstruction';
import IPsleInstruction from './IPsleInstruction';
import NonNationalInstruction from './NonNationalInstruction';

const ExamInstruction = (props: { examType: string }) => {
  const { examType } = props;

  if (examType === 'PSLE') {
    return <PsleInstruction />;
  }

  if (examType === 'GCE') {
    return <GceInstruction />;
  }

  if (examType === 'Non-National') {
    return <NonNationalInstruction />;
  }

  return <IPsleInstruction />;
};

export default ExamInstruction;
